<ng-content></ng-content>

<div class="scheduler-container">
  <div #schedulerContainer>
    <cam-scheduler-widget
      #schedulerRef
      [columns]="this.columns"
      [resources]="this.resources()"
      [resourceTimeRanges]="this.resourceTimeRanges()"
      [autoHeight]="true"
      [rowHeight]="85"
      [allowOverlap]="false"
      [events]="this.events()"
      [workingTime]="this.workingTime"
      [eventDragFeature]="true"
      [eventResizeFeature]="true"
      [eventRenderer]="this.eventRenderer"
    ></cam-scheduler-widget>
  </div>
</div>
